import type * as React from 'react';

export default function getAnchorElementForContextMenu(
    evt: React.MouseEvent<HTMLElement>
): Element {
    return evt.currentTarget;
}
